<template>
    <div class="rich-text-wrapper" v-if="component">
        <div class="container-fluid">
            <div class="card">
                <div class="card-header" v-if="component.name">
                    <div class="title">
                        <h2>{{component.name}}</h2>
                    </div>
                </div>
                <div class="rich-text m-2">
                    <div :id="'editor-' + component.id" style="min-height:300px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    //add functionality for storing and displaying delta from quill
    import Quill from 'quill';

    export default {
        name: 'RichTextComponent',
        props: ["initialComponent"],
        data: function () {
            return {
                editor: null,
                value: null,
                component: null,
            };
        },
        watch: {
            initialComponent: {
                immediate: true,
                handler(value) {
                    this.component = value || null;
                }
            }
        },
        methods: {
            //try moving the init method outside the component
            initializeQuill() {
                if (!this.component || !this.component.id) {
                    return;
                }

                var editorId = "#editor-" + this.component.id;

                this.editor = new Quill(editorId, {
                    theme: 'snow',
                    placeholder: "Enter text here..."
                });
                console.log("Initializing", this.component);
                if (this.component.html) {
                    var delta = this.editor.clipboard.convert(this.component.html);
                    console.log("Has html", { delta });
                    this.editor.setContents(delta, 'silent');
                }
                else {
                    console.log("No html");
                    this.editor.setContents([{ insert: '\n' }]);
                }
            },
            setQuillContents() {
                if (!this.editor || !this.component) {
                    return;
                }

                console.log("Setting contents", this.component);
                //will either be value from html or text
                if (this.component.type && this.component.type == 'text') {
                    console.log("Is text");
                    this.value = this.component.html;
                    this.editor.root.innerHTML = this.component.html;
                }
                else {
                    console.log("Not text");
                    this.value = this.component.html;
                    this.editor.root.innerHTML = this.component.html;
                }
            },
            setComponentHtml() {
                if (!this.editor || !this.component) {
                    return;
                }

                //on text change update component html
                console.log("Setting html");
                var value = this.editor.root.innerHTML;
                this.$emit("htmlChanged", value, this.component.id);
            }
        },
        mounted: function () {
            if (!this.component || !this.component.id) {
                return;
            }

            this.initializeQuill();
            this.setQuillContents();
            this.editor.on('text-change', () => {
                this.setComponentHtml();
            });
            //on load set value to component html
        },
    }
</script>

<style scoped>
</style>
